export const title = 'RECENT NEWS';

export const btnTitle = 'See more post >';
